module.exports = __webpack_public_path__ + "static/img/CgoRC2RBBAWANey0AAuZO3GI0zI815.0c96236.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2RBBAWANey0AAuZO3GI0zI815.jpg
// module id = qv00
// module chunks = 73